var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { useMemo, useRef } from 'react';
import { Typography } from '@lucidlink/uicore';
import { useSerializedStats } from '../../../query-hooks';
import { MetricsTable } from './components';
export const FileSystemMetrics = ({ stats }) => {
    _react_refresh_temp_2();
    const lastSerializedStats = useRef(undefined);
    const { query: { data: serializedStats }, } = useSerializedStats('file_system', stats);
    const metrics = useMemo(() => {
        if (!serializedStats) {
            return undefined;
        }
        let bytesReadPerSecond = 0;
        let bytesWrittenPerSecond = 0;
        if (lastSerializedStats.current) {
            bytesReadPerSecond =
                serializedStats.totalBytesRead -
                    lastSerializedStats.current.totalBytesRead;
            bytesWrittenPerSecond =
                serializedStats.totalBytesWritten -
                    lastSerializedStats.current.totalBytesWritten;
        }
        lastSerializedStats.current = serializedStats;
        return [
            {
                name: 'ReadDir Calls',
                value: serializedStats?.readDir.success.count,
            },
            {
                name: 'ReadFile Calls',
                value: serializedStats?.readFile.success.count,
            },
            {
                name: 'Total Bytes Read',
                value: serializedStats?.totalBytesRead,
            },
            {
                name: 'Bytes Read/s',
                value: bytesReadPerSecond,
            },
            {
                name: 'Total Bytes Written',
                value: serializedStats?.totalBytesWritten,
            },
            {
                name: 'Bytes Written/s',
                value: bytesWrittenPerSecond,
            },
        ];
    }, [serializedStats]);
    return metrics ? (_jsx(MetricsTable, { data: metrics })) : (_jsx(Typography, { color: "negative", kind: "h5", children: "Cannot load File System metrics" }));
};
_react_refresh_temp_1 = FileSystemMetrics;
$RefreshReg$(_react_refresh_temp_1, "FileSystemMetrics");
_react_refresh_temp_2(FileSystemMetrics, "8XzU2rsUs8UvLJK7GZwAhqYLPTc=", false, () => [useSerializedStats]);
